import { api } from './client';

export interface CleaningRecord {
  id: number;
  roomId: string;
  cleaningDate: string;
  isCleaned: boolean;
  cleanerId?: number;
  cleaningType: string;
  cleaningTime?: string;
  memo?: string;
  cleaner?: {
    id: number;
    name: string;
  };
}

export const cleaningApi = {
  // 재실청소 추가/업데이트
  addJaesil: async (roomId: string, date: string, memo?: string) => {
    const response = await api.put('/cleaning/jaesil', {
      roomId,
      date,
      memo,
    });
    return response.data.data as CleaningRecord;
  },

  // 재실청소 삭제
  deleteJaesil: async (roomId: string, date: string) => {
    const response = await api.delete(`/cleaning/jaesil/${roomId}/${date}`);
    return response.data;
  },

  // 청소 기록 조회
  getCleaningRecords: async (roomId: string, startDate?: string, endDate?: string) => {
    const params: any = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const response = await api.get(`/cleaning/records/${roomId}`, { params });
    return response.data.data as CleaningRecord[];
  },
};
